
import { Component, Vue } from 'vue-property-decorator'
import { baseShareDetail } from '@/api'
@Component({
    name: 'videoPlayer'
})
export default class extends Vue {
    private editData: any = {}
    private isShowTitle = true
    get showIframe() {
        return this.editData.resSubType === 23
    }
    private async getDetail() {
        const routerParam = this.$route.params
        this.isShowTitle = routerParam.type === '1'
        const res = await baseShareDetail(routerParam.id)
        this.editData = res.data
    }
    created() {
        this.getDetail()
    }
}
